import { GetSynopticByIdResponseSchema } from '@shared/schema/synoptic.get-by-id.schema'
import { queryOptions } from '@tanstack/react-query'

import { apiFetch } from '@/lib/api-fetch'

// Source unique de la clé de query d'un synoptic, partagée avec les mutations pour l'invalidation.
export function synopticQueryKey(id: number) {
  return ['synoptic', id] as const
}

export function synopticQuery(id: number) {
  return queryOptions({
    queryKey: synopticQueryKey(id),
    async queryFn() {
      const rawResponse = await apiFetch.get(`synoptic/${id}`)

      if (!rawResponse.ok) {
        throw new Error(`Failed to fetch synoptic ${id}`)
      }

      try {
        return await GetSynopticByIdResponseSchema.parseAsync(await rawResponse.json())
      } catch (error) {
        throw new Error('Failed to parse synoptic response', { cause: error })
      }
    },
  })
}
